import React, { FC, useCallback } from 'react';
import { Dayjs } from 'dayjs';
import {
  FormDateRangePicker,
  FormDateRangePickerProps,
  getDayjs,
} from '@atlas-frontend/sdk';

export type CategoryValidPeriodPickerProps = FormDateRangePickerProps & {
  classifierValidPeriod: [string | null, string | null];
};

export const CategoryValidPeriodPicker: FC<CategoryValidPeriodPickerProps> = (
  props
) => {
  const { classifierValidPeriod, ...rest } = props;

  const disabledCategoryDate = useCallback(
    (date: Dayjs) =>
      Boolean(
        (classifierValidPeriod?.[0] &&
          getDayjs(classifierValidPeriod?.[0])?.isAfter(date, 'day')) ||
          (classifierValidPeriod?.[1] &&
            getDayjs(classifierValidPeriod?.[1])?.isBefore(date, 'day'))
      ),
    [classifierValidPeriod]
  );

  return (
    <FormDateRangePicker
      {...rest}
      allowEmpty={[true, true]}
      disabledDate={disabledCategoryDate}
    />
  );
};
